import {Component, Inject, OnInit} from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Observable, takeWhile, timer} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-session-timeout-warn-dialog',
  templateUrl: './session-timeout-warn-dialog.component.html',
  styleUrl: './session-timeout-warn-dialog.component.scss'
})
export class SessionTimeoutWarnDialogComponent implements OnInit {

  millSeconds: number;

  countdown$: Observable<number>;

  constructor(
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<SessionTimeoutWarnDialogComponent>,
  ) {
    this.millSeconds = data;
  }

  ngOnInit(): void {
    this.countdown$ = timer(0, 1000).pipe(
      map(secondsElapsed => (this.millSeconds / 1000) - secondsElapsed),
      takeWhile(value => value >= 0)
    );
  }

  logOut() {
    this.close();
    this.authService.logout();
  }

  close() {
    this.dialogRef.close();
  }

}
